import { createFileRoute } from "@tanstack/react-router";
import { UniversityDocumentation } from "@/components/University";

function RouteComponent() {
  return <UniversityDocumentation />;
}

export const Route = createFileRoute("/_authenticated/atlas/overview/")({
  component: RouteComponent,
  staticData: { page: "university" },
});
